import React, {useEffect} from 'react'
import Aos from "aos"
import "aos/dist/aos.css"
import "../CSS/Project.css"
const Project = () => {

    useEffect(() => {
        Aos.init({duration:2000});
     }, []);
    return (       
       
       <>  
           <div className ="backProject">
               <div className="containerProject">
                       <div data-aos="fade-down" className="headerProject">
                           <h1>My Projects</h1>
                       </div>
                       <div className="pack-section">
                            <ul className="pack-grig">
                                <li>
                                    <div className="pack-box pack-img-1">
                                        <div className="pack-info">
                                            <h3>Movie-o-Pedia</h3>
                                            <p>WEB/API</p>
                                            <a href = "https://movie-o-pedia718.netlify.app" target="blank">
                                                <button className='custom-btn btn-6'>View</button>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="pack-box pack-img-1">
                                        <div className="pack-info">
                                           <h3>Dummy</h3>
                                           <p>dummy/dummy</p>
                                           <a href = "!#" target="blank">
                                                <button className='custom-btn btn-6'>View</button>
                                           </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="pack-box pack-img-1">
                                        <div className="pack-info">
                                            <h3>Dummy</h3>
                                            <p>Dummy/dummy</p>
                                            <a href = "!#" target="blank">
                                                <button className='custom-btn btn-6'>View</button>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="pack-box pack-img-1">
                                    <div className="pack-info">
                                            <h3>Dummy</h3>
                                            <p>Dummy/dummy</p>
                                            <a href = "!#" target="blank">
                                                <button className='custom-btn btn-6'>View</button>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                </div>
            </div>
        
       </>
    )
}

export default Project

